import { render } from "./FxModalHeader.vue?vue&type=template&id=84a1d7c4"
import script from "./FxModalHeader.vue?vue&type=script&lang=js"
export * from "./FxModalHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__